import React, { useState } from "react";
import s from "./search.module.css";
import { useDispatch } from "react-redux";
import { searchName } from "../../redux/actions";

export default function SearchBar({ setCurrentPage }) {
  const [state, setState] = useState("");
  const dispatch = useDispatch();

  function handleChange(e) {
    e.preventDefault();
    setState(e.target.value);
    console.log(e.target.value);
  }

  function handleSubmit(e) {
    e.preventDefault();
    dispatch(searchName(state));
    setState(""); //para limpiar mi busqueda
    setCurrentPage(1);
  }

  return (
    <>
      <form onSubmit={(e) => handleSubmit(e)}>
        <div className={s.inputSearch}>
          <input
            type="text"
            id="name"
            autoComplete="off"
            placeholder="Search"
            value={state}
            maxLength="100"
            onChange={handleChange}
          />
          <button className={s.btnSearch} type="submit">
            {" "}
          </button>
        </div>
      </form>
    </>
  );
}
